import React, { useEffect, useState } from "react";
import { eliminarImagenMacro, obtenerImagenesMacros, obtenerImagenesMacrosGestion } from "../services/imagenesservice";
import LoaderDialog from "./loading";

export default function GestorImagenes({ setGestionarMacros }) {
    const [imagenes, setImagenes] = useState([]);
    const [mensaje, setMensaje] = useState("");
    const [imagenSeleccionada, setImagenSeleccionada] = useState(null);
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");

    // Manejador del cambio de archivo
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    // Manejador del envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!file) {
            setMessage("Por favor selecciona un archivo.");
            return;
        }

        const formData = new FormData();
        formData.append("archivo", file);

        try {
            // Cambia la URL a la ruta donde está tu archivo PHP
            const response = await fetch("./upload.php", {
                method: "POST",
                body: formData,
            });

            if (response.ok) {
                const result = await response.json();
                setMessage(result.success || "Archivo subido con éxito.");
            } else {
                const error = await response.json();
                setMessage(error.error || "Error al subir el archivo.");
            }
        } catch (error) {
            console.error("Error:", error);
            setMessage("Hubo un problema al subir el archivo.");
        }
    };
    const salirDeMacros = () => {
        setGestionarMacros(false); // Cambiar el estado en el componente padre
    };

    const cargarImagenes = async () => {
        setLoading(true)
        try {

            const data = await obtenerImagenesMacros();
            setImagenes(data);
        } catch (error) {
            console.error("Error al cargar imágenes", error);
        }finally{
            setLoading(false)
        }
    };

    const eliminarImagen = async (nombreImagen) => {
        try {
            const data = await eliminarImagenMacro(nombreImagen);
            alert(data.mensaje);
        } catch (error) {
            alert("Error al eliminar la imagen: " + error.message);
        }
    };

    useEffect(() => {
        cargarImagenes();
    }, []);

    return (<>
        <LoaderDialog visible={loading} />
        <div className="container mt-4 text-center">
            <h2 className="m-4">Makros</h2>
            <form onSubmit={handleSubmit} className="mt-4">
                <div className="row">
                    <div className="col-8">
                        <div className="mb-3">
                            <input
                                type="file"
                                className="form-control"
                                id="archivo"
                                onChange={handleFileChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="col-4">
                        <button type="submit" className="btn btn-consulta ">
                            Subir makro
                        </button>
                    </div>

                </div>


            </form>
            {mensaje && <div className="alert alert-info">{mensaje}</div>}
            <div className="row">
                {imagenes.map((imagen, index) => (
                    <div className="col-md-4 mb-3" key={index}>
                        <div className="card position-relative">
                            <img
                                src={`${imagen.imagen}`}
                                alt={`Imagen ${index}`}
                                className="card-img-top efect"
                                style={{ height: "150px", objectFit: "cover", cursor: "pointer" }}
                                onClick={() => setImagenSeleccionada(imagen.imagen)}
                            />
                            <div
                                className="image-overlay"
                                style={{
                                    position: "absolute",
                                    bottom: 90,
                                    left: 0,
                                    width: "100%",
                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    color: "white",
                                    textAlign: "center",
                                    padding: "5px 0",
                                    fontSize: "14px",
                                }}
                            >
                                {imagen.nombre} {/* Extrae solo el nombre del archivo */}
                            </div>
                            <div className="card-body text-center">
                                <button
                                    className="btn btn-danger btn-sm me-2"
                                    onClick={() => eliminarImagen(imagen.nombre)}
                                >
                                    Eliminar
                                </button>
                            </div>
                        </div>
                    </div>
                ))}

            </div>
            <div class="row ">
                <div class="col-12 d-flex justify-content-center">

                    <button className="btn btn-consulta btn-sm"
                        onClick={salirDeMacros}>
                        Regresar a gestión
                    </button>
                </div>
            </div>

            {/* Modal para ver imagen */}
            {imagenSeleccionada && (
                <div
                    className="modal fade show d-block"
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content vh-75">
                            <div className="modal-header">
                                <h6 className="modal-title">Vista de la imagen</h6>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => setImagenSeleccionada(null)}
                                ></button>
                            </div>
                            <div className="modal-body text-center">
                                <img
                                    src={`${imagenSeleccionada}`}
                                    alt="Vista previa"
                                    className="img-fluid"
                                />
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </div>
    </>
    );
}
